import {
  AxisStructuredDataInquiryType,
  AxisStructuredDataTypeEnum,
} from '../../gql/graphql';
import type { AxisStructuredData } from '../../store/axisStore';
import { axisPaths } from './AxisConstants';

export type AxisTopLevelStructuredData = Pick<
  AxisStructuredData,
  'inquiryType' | 'type'
>;

export type AxisInquiryOption = {
  label: string;
  url: string;
  structuredData: AxisTopLevelStructuredData;
};

export const AXIS_NEW_CLIENT_INQUIRY_OPTION: AxisInquiryOption = {
  label: 'New Client',
  url: axisPaths.newClient.url,
  structuredData: {
    inquiryType: AxisStructuredDataInquiryType.NewClient,
    type: AxisStructuredDataTypeEnum.NewClient,
  },
};

export const AXIS_CURRENT_CLIENT_INQUIRY_OPTION: AxisInquiryOption = {
  label: 'Current / Former Client',
  url: axisPaths.currentClient.url,
  structuredData: {
    inquiryType: AxisStructuredDataInquiryType.CurrentClient,
    type: AxisStructuredDataTypeEnum.CurrentOrFormerClient,
  },
};

export const AXIS_CLAIMS_INQUIRY_OPTION: AxisInquiryOption = {
  label: 'Claims Inquiry',
  url: axisPaths.claimsInquiry.url,
  structuredData: {
    inquiryType: AxisStructuredDataInquiryType.ClaimsInquiry,
    type: AxisStructuredDataTypeEnum.Claims,
  },
};

export const AXIS_PAYMENTS_INQUIRY_OPTION: AxisInquiryOption = {
  label: 'Payments',
  url: axisPaths.payments.url,
  structuredData: {
    inquiryType: AxisStructuredDataInquiryType.FinanceOrPayment,
    type: AxisStructuredDataTypeEnum.Payments,
  },
};

export const AXIS_PROMOTIONAL_INQUIRY_OPTION: AxisInquiryOption = {
  label: 'Promotional',
  url: axisPaths.promotional.url,
  structuredData: {
    inquiryType: AxisStructuredDataInquiryType.MarketingOrPromotional,
    type: AxisStructuredDataTypeEnum.Promotional,
  },
};

export const AXIS_OTHER_INQUIRY_OPTION: AxisInquiryOption = {
  label: 'Other Inquiry',
  url: axisPaths.otherInquiry.url,
  structuredData: {
    inquiryType: AxisStructuredDataInquiryType.OtherInquiry,
    type: AxisStructuredDataTypeEnum.Other,
  },
};

export const AXIS_INQUIRY_OPTIONS: Array<AxisInquiryOption> = [
  AXIS_NEW_CLIENT_INQUIRY_OPTION,
  AXIS_CURRENT_CLIENT_INQUIRY_OPTION,
  AXIS_CLAIMS_INQUIRY_OPTION,
  AXIS_PAYMENTS_INQUIRY_OPTION,
  AXIS_PROMOTIONAL_INQUIRY_OPTION,
  AXIS_OTHER_INQUIRY_OPTION,
];

export const AXIS_CURRENT_CLIENT_STRUCTURED_DATA =
  AXIS_CURRENT_CLIENT_INQUIRY_OPTION.structuredData;
export const AXIS_CLAIMS_INQUIRY_STRUCTURED_DATA =
  AXIS_CLAIMS_INQUIRY_OPTION.structuredData;
export const AXIS_PAYMENTS_STRUCTURED_DATA =
  AXIS_PAYMENTS_INQUIRY_OPTION.structuredData;
export const AXIS_PROMOTIONAL_STRUCTURED_DATA =
  AXIS_PROMOTIONAL_INQUIRY_OPTION.structuredData;
export const AXIS_OTHER_INQUIRY_STRUCTURED_DATA =
  AXIS_OTHER_INQUIRY_OPTION.structuredData;
